import React from 'react';

interface PageHeaderSimpleProps {
  title: string;
  subtitle: string;
  metaRow?: {
    lastUpdated: string;
    coverage: string;
    privacy: string;
  };
  contextNote?: string;
}

export const PageHeaderSimple: React.FC<PageHeaderSimpleProps> = ({
  title,
  subtitle,
  metaRow,
  contextNote,
}) => {
  return (
    <div className="mb-8 text-center">
      {/* Title */}
      <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-2">
        {title}
      </h1>

      {/* Meta Row */}
      {metaRow && (
        <div className="flex flex-wrap gap-2 text-sm text-gray-500 mb-4 justify-center">
          <span>Last updated: {metaRow.lastUpdated}</span>
          <span className="text-gray-300">|</span>
          <span>Coverage: {metaRow.coverage}</span>
          <span className="text-gray-300">|</span>
          <span>Privacy: {metaRow.privacy}</span>
        </div>
      )}

      {/* Subtitle */}
      <p className="text-xl text-gray-600 mb-4 italic">{subtitle}</p>

      {/* Context Note */}
      {contextNote && (
        <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
          {contextNote}
        </p>
      )}
    </div>
  );
};
